module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "confirm",
    attrs: {
      "width": 500
    }
  }, [_c('div', {
    staticClass: "confirmation-modal-text"
  }, [_vm._v("\n    You have unsaved changes on your target.\n    Are you sure you would like to disregard your changes?\n  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('v-btn', {
    attrs: {
      "id": "confirmSaveBtn",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelHandler.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveButton))]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "id": "confirmGoToDashboardBtn",
      "color": "light-blue lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Continue to Dashboard")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f40bbb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/saveChanges/SaveWorkbenchChangesModal.vue
// module id = 1942
// module chunks = 0